// extracted by mini-css-extract-plugin
export var brand = "_az-9";
export var compact = "_az-6";
export var extraSmall = "_az-7";
export var icon = "_az-0";
export var large = "_az-4";
export var light = "_az-1";
export var medium = "_az-5";
export var outline = "_az-b";
export var primaryDark = "_az-a";
export var primaryLight = "_az-8";
export var primaryModern = "_az-c";
export var success = "_az-2";
export var successSolid = "_az-3";